"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
exports.default = theme => ({
    root: {
        width: `calc(100vw - ${constants_1.VIEWPORT_MARGIN}px - ${constants_1.VIEWPORT_MARGIN}px)`,
        maxWidth: constants_1.MODAL_MAX_WIDTH_SMALL,
        maxHeight: 'inherit',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.white1,
        borderRadius: 5,
        boxShadow: `0 0 2px 0 rgba(0,0,0,0.2)`,
        '&[data-is-large=true]': {
            maxWidth: constants_1.MODAL_MAX_WIDTH_LARGE
        },
        '&[data-is-fullscreen=true]': {
            maxWidth: 'unset'
        }
    }
});
//# sourceMappingURL=modal.style.js.map